import { getBlockRenderer } from './registry';
import { ContentBlockRenderer } from './renderers/ContentBlockRenderer';
import type { Block } from './types';

interface BlockRendererProps {
  block: Block;
}

export function BlockRenderer({ block }: BlockRendererProps) {
  const Renderer = getBlockRenderer(block.type) ?? ContentBlockRenderer;
  return <Renderer block={block} />;
}
